import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Board } from './Board';
import NewIdeaModal from './NewIdeaModal';
import TagFilter from './TagFilter';
import { useEPMContext } from '../../../contexts/EPMContext';
import { useUserContext } from '../../../contexts/UserContext';
import { permission } from '../../../config/permission';
import TestPeekModal from './TestPeekModal';
import Button from '../../UI/Button';

export { Board } from './Board';
export * from './constants';

const TestingBoard = () => {
    const [isNewIdeaModalOpen, setIsNewIdeaModalOpen] = useState(false);
    const [selectedTestId, setSelectedTestId] = useState(null);
    const [searchParams] = useSearchParams();
    // ?tag=<id> (from Home's tag breakdown) opens the board already filtered
    const [tagFilter, setTagFilter] = useState(() => searchParams.getAll('tag'));
    const { tests, tagsMap } = useEPMContext();
    const { checkPermission } = useUserContext();

    return (
        <div className="w-full px-4 md:px-8 py-6">
            <div className="flex justify-between items-center gap-4 mb-5 flex-wrap">
                <TagFilter tests={tests} tagsMap={tagsMap} selected={tagFilter} onChange={setTagFilter} />
                {checkPermission(permission.XCM_TESTS_CREATE) && (
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={() => setIsNewIdeaModalOpen(true)}
                        className="ml-auto shrink-0 whitespace-nowrap"
                    >
                        + New Idea
                    </Button>
                )}
            </div>
            <Board onTestClick={setSelectedTestId} tagFilter={tagFilter} />
            {isNewIdeaModalOpen && (
                <NewIdeaModal hideModal={() => setIsNewIdeaModalOpen(false)} />
            )}
            {selectedTestId && (
                <TestPeekModal testId={selectedTestId} onClose={() => setSelectedTestId(null)} />
            )}
        </div>
    );
};

export default TestingBoard;
